import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { styled } from '@mui/styles';
import { PmiButton } from 'shell/components/shared/button';
import { memo } from 'react';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '25rem',
        maxWidth: '30rem',
      },
}));

interface ErrorModalProps {
  open: boolean;
  onClose: (open: boolean) => void;
  warnings: Array<string>;
}

const ErrorModalComponent = ({ open, onClose, warnings }: ErrorModalProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      fullScreen={fullScreen}
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="cdmBrand" color="white">
        Attenzione!
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <div className="pmi-pb-2">
          <Typography>Si sono verificati i seguenti warning:</Typography>
        </div>
        {warnings.map((warning, index) => (
          <div key={index.toString()} className="pmi-pb-2">
            <Typography>
              {index + 1}: {warning}
            </Typography>
          </div>
        ))}
      </DialogContent>
      <DialogActions>
        <PmiButton variant="outlined" color="primary" type="button" onClick={() => onClose(false)}>
          chiudi
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ErrorModalComponent.displayName = 'Modal error';

const ErrorModal = memo(ErrorModalComponent);

export default ErrorModal;
